import { render, staticRenderFns } from "./DeleteUserDialog.vue?vue&type=template&id=d2faab44&scoped=true&"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2faab44",
  null
  
)

export default component.exports